// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__BDobi","newExpiryDate":"styles_newExpiryDate__2H01K","footer":"styles_footer__14XPA"};